// extracted by mini-css-extract-plugin
export default {"wrapper":"Likes_wrapper__uh-9U"};